module.exports = __webpack_public_path__ + "static/img/gggggg_24.23a9f91.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/resources/images/icon/gggggg_24.png
// module id = vQkg
// module chunks = 1